import { api } from "../../utils/api";

export const getIndexReadjustment = async (id, setLoading) => {
  setLoading(true);
  const response = await api.get(`index/${id}`);
  const data = response.data.config_index.map((dado) => ({
    id: dado.id,
    index: dado.index,
    name: dado.name,
    fee: dado.fee,
    index_id: id,
  }));
  setLoading(false);
  return data;
};
